import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetLsrafDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_LSRAF_DETAILS, token);
  return res;
};

export const AddLsraf = async (payload) => {
  const token = localStorage.getItem("token");

  let res = await Services.POST(Url.ADD_LSRAF,payload, token);
  return res;
};

export const DeleteLsraf = async (LsrafId) => {
  const token = localStorage.getItem("token");
  const params = { LsrafId };
  let res = await Services.DELETE(Url.DELETE_LSRAF + LsrafId, params, token);
  return res;
};

export const UpdateLsraf = async (LsrafId, payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.UPDATE_LSRAF + LsrafId, payload, token);
  return res;
};
